import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SelectedDocumentCardProps {
  selectedFileName?: string;
  contentPreview?: string;
  disabled?: boolean;
  onChange: () => void;
  onClear: () => void;
}

const PREVIEW_LIMIT = 500;

const SelectedDocumentCard: React.FC<SelectedDocumentCardProps> = ({
  selectedFileName,
  contentPreview,
  disabled = false,
  onChange,
  onClear,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-2 rounded-xl border bg-card px-4 py-3 text-card-foreground">
      <div className="flex items-center justify-between">
        <div className="flex min-w-0 items-center gap-2">
          <FileText className="size-5 shrink-0 text-primary" strokeWidth={1.9} />
          <div className="min-w-0">
            <p className="revy-cjk truncate text-sm font-medium leading-[1.5]" title={selectedFileName}>
              {selectedFileName || t('drbfm.documentSelector.documentSelected')}
            </p>
            <p className="revy-cjk text-xs leading-[1.5] text-muted-foreground">
              {t('drbfm.documentSelector.selected')}
            </p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onChange} disabled={disabled}>
            <span className="revy-cjk">{t('drbfm.documentSelector.change', '変更')}</span>
          </Button>
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={onClear}
            disabled={disabled}
            aria-label={t('common.clear')}
            className="text-destructive hover:text-destructive"
          >
            <X strokeWidth={1.9} />
          </Button>
        </div>
      </div>

      {contentPreview && (
        <div className="mt-2 max-h-[150px] overflow-auto rounded-md border bg-muted/50 p-2">
          <pre className="revy-cjk m-0 whitespace-pre-wrap break-words font-mono text-xs leading-[1.5]">
            {contentPreview.slice(0, PREVIEW_LIMIT)}
            {contentPreview.length > PREVIEW_LIMIT && '...'}
          </pre>
        </div>
      )}
    </div>
  );
};

export default SelectedDocumentCard;
